export default __webpack_public_path__ + "static/media/Screenshot_2023-09-21_113739-transformed.a4bc4dce.png";